import React, { useEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom';
import Footer from './components/footer/Footer';
import SystemAdminHeader from './components/header/SystemAdminHeader';
import Sidebar from './components/system-admin-sidebar/Sidebar';
import { PageDataProvider } from './core/PageData';
import { MenuComponent } from '../assets/ts/components/MenuComponent';
import { ToggleComponent } from '../assets/ts/components/ToggleComponent';
const SystemAdminLayout = () => {
    const { company } = useParams();
    const location = useLocation()
    
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
            ToggleComponent.reinitialization()
        }, 500);
    })

    return (
        <>
            <PageDataProvider>
                <div className='d-flex flex-column flex-root app-root' id='sai_app_root'>
                    <div className='app-page flex-column flex-column-fluid' id='sai_app_page'>
                        <SystemAdminHeader/>
                        <div className='app-wrapper flex-column flex-row-fluid' id='sai_app_wrapper'>
                            {company && <Sidebar />}
                            <div className='d-flex flex-column flex-row-fluid vh-90' id='sai_app_main'>
                                <div className='d-flex flex-column flex-column-fluid flex-grow-1'>
                                    <div id="sai_app_content" className="app-content flex-column-fluid">
                                        <div id="sai_app_content_container" className="app-container container-xxl">
                                            <Outlet />
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </div>
                </div>
            </PageDataProvider>
        </>
    )
}
export default SystemAdminLayout